import axios from 'axios'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import Header from '../components/Header'
import Navbar from '../components/Navbar'
import { EXAM } from '../services/routes'
import Modal from 'react-modal'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import { Footer } from '../components/Footer'

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        minWidth: '500px',
        bottom: 'auto',
        marginRight: '-50%',
        backgroundColor: 'white',
        transform: 'translate(-50%, -50%)',
    },
};

const Exams = () => {

    const [exams, setExams] = useState([])
    const [details, setDetails] = useState()
    const [textSearch, setTextSearch] = useState('')

    const [showPostModal, setShowPostModal] = useState(false)
    const [modalIsOpen, setIsOpen] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false)

    const token = localStorage.getItem('token')

    const getExams = () => {
        axios(EXAM.GETALL, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(json => {
                console.log(json.data)
                setExams(json.data)
            })
    }

    const formatDate = item => {
        let date = new Date(item)
        let day = date.getDate() + 1 < 10 ? `0${date.getDate() + 1}` : date.getDate() + 1
        let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
        let year = date.getFullYear()

        return `${day}/${month}/${year}`
    }

    const togglePostModal = (item) => {
        setIsOpen(!modalIsOpen);
        let date = new Date(item.date)
        let day = date.getDate() + 1 < 10 ? `0${date.getDate() + 1}` : date.getDate() + 1
        let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
        let year = date.getFullYear()
        item.dataExame = `${day}/${month}/${year}`
        setDetails(item)
        setShowPostModal(!showPostModal)
    }

    const toggleModalDelete = (item) => {
        setIsOpen(!modalIsOpen)
        setDetails(item)
        setShowModalDelete(!showModalDelete)
    }

    const deleteExam = async (id) => {
        try {
            await axios.delete(`${EXAM.REMOVE.replace(/:id/gi, id)}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                })
            toast.success('Exame deletado!')
            getExams()
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {

        getExams()

    }, [])

    return (
        <>
            <Helmet>
                <title>Exames - Coluço System</title>
            </Helmet>
            <div id="wrapper">

                {showPostModal && <Modal
                    ariaHideApp={false}
                    isOpen={modalIsOpen}
                    onRequestClose={togglePostModal}
                    style={customStyles}
                    contentLabel="Modal de Exames"
                >
                    <button className="btn btn-danger float-right" onClick={togglePostModal}>X</button>
                    <h2 className="mb-4">Informações do Exame</h2>

                    <b>Nome do paciente: </b> {details?.patient?.name} {details?.patient?.lastname} <br />
                    <b>Tipo de exame:</b> {details?.type?.title} <br />
                    <b>Data:</b> {details?.dataExame}<br />
                    <b>Descrição:</b><br /> {details?.type?.description !== '' ? details?.type?.description : <span style={{ color: "red" }}>Sem descrição</span>} <br />
                </Modal>}

                {showModalDelete && <Modal
                    ariaHideApp={false}
                    isOpen={modalIsOpen}
                    onRequestClose={toggleModalDelete}
                    style={customStyles}
                    contentLabel="Modal de Deletar Exame"
                >
                    <button className="btn btn-danger float-right" onClick={toggleModalDelete}>X</button>
                    <h2 className="mb-4">Deletar exame</h2>

                    <h5 className="align-center">Tem certeza que quer excluir este exame?</h5>

                    <div className="d-flex mt-5 mb-4 justify-content-center">
                        {console.log(details)}
                        <button className="me-3 btn btn-danger" onClick={async () => {
                            await deleteExam(details._id)
                            toggleModalDelete()
                        }}>Excluir</button>
                        <button className="btn btn-primary" onClick={toggleModalDelete}>Fechar</button>
                    </div>

                </Modal>}

                <Header active="exams" />

                <div id="content-wrapper" className="d-flex flex-column">

                    <div id="content">

                        <Navbar />

                        <div className="container-fluid">

                            <h1 className="h3 mb-2 text-gray-800">Exames</h1>

                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">Lista de exames</h6>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6" />
                                            <div className="col-sm-12 col-md-6">
                                                <div className="dataTables_filter text-right mb-2">
                                                    <input type="search" onChange={e => setTextSearch(e.target.value)} className="form-control" placeholder="Digite o nome do paciente ou CPF" />
                                                </div>
                                            </div>
                                        </div>
                                        <table className="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>Nome do Paciente</th>
                                                    <th>Tipo de Exame</th>
                                                    <th>Data</th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {exams.filter(item => {
                                                    if (textSearch === '') {
                                                        return item
                                                    }
                                                    else if (item.patient.name.toLowerCase().includes(textSearch.toLowerCase()) || item.patient.cpf.toLowerCase().includes(textSearch.toLowerCase())) {
                                                        return item
                                                    }
                                                }).map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            {item.patient !== null ?
                                                                <td>{item?.patient?.name} {item?.patient?.lastname}</td>
                                                                :
                                                                <td>Paciente não encontrado</td>
                                                            }
                                                            <td>{item?.type?.title}</td>
                                                            <td>{formatDate(item?.date)}</td>
                                                            <td>
                                                                <button title="Detalhes" className="btn btn-secondary me-1" onClick={() => togglePostModal(item)}><i className="fas fa-info fa-fw"></i></button>
                                                                <Link title="Editar" className="btn btn-success me-1" to={`/exams/edit/${item._id}`}><i className="fas fa-pen fa-fw "></i></Link>
                                                                <button title="Excluir" className="btn btn-danger" onClick={() => toggleModalDelete(item)}><i className="fas fa-trash fa-fw"></i></button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    {exams.length <= 0 ?
                                        <div className="d-flex justify-content-center">
                                            <h6 className="">Não há exames cadastrados</h6>
                                        </div>
                                        :
                                        ''
                                    }
                                </div>
                            </div>

                        </div>

                    </div>

                    <Footer />

                </div>

            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
        </>
    )
}

export default Exams
